// Render plugin for `warehouse_query` SSE events.
//
// The agent's warehouse_query tool runs one read-only query and emits this
// event: the connection, the SQL, the first 50 rows and the counts. The card
// draws from that payload alone, so it is the same live, after a reload and on
// a colleague's view. The owner can edit the SQL and re-run it from the card
// (browser route, no agent turn, no AI credits); see WarehouseQueryCard.
import React from 'react'
import type { RenderPlugin, PluginAgentSSEEvent } from '../agent'
import { pluginEventId } from '../agent'
import { WarehouseQueryCardContainer } from '../components/agent/WarehouseQueryCard'
import { warehouseEventFromData, type WarehouseQueryEvent } from '../components/agent/warehouseQueryTypes'

type WarehousePluginState = WarehouseQueryEvent

export const warehouseQueryPlugin: RenderPlugin<WarehousePluginState | null> = {
  eventTypes: ['warehouse_query'],

  init(): WarehousePluginState | null {
    return null
  },

  // One query per tool call: a later event for the same call replaces it.
  reduce(state: WarehousePluginState | null, event: PluginAgentSSEEvent): WarehousePluginState | null {
    // The one query of the tool call is item 0, so its key matches the Notebook cell's.
    return warehouseEventFromData(event.data, pluginEventId(event.data, 0)) ?? state
  },

  render({ state, toolCallId, sessionId }) {
    if (!state) return null
    // Keyed by tool call so each card keeps its own edit state.
    return <WarehouseQueryCardContainer key={toolCallId} event={state} sessionId={sessionId} />
  },
}

export default warehouseQueryPlugin
